import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "@/components/common/Logo";

const SECTIONS = [
  ["Overview", "This Privacy Policy explains how Vozelto (\"we\", \"us\") collects, uses, and protects information when you use our platform."],
  ["Information we collect", "Account details (name, email), workspace and content you create, and usage data needed to operate the service. Payment information is processed securely by Stripe; we do not store full card numbers."],
  ["How we use information", "To provide and improve the service, authenticate you, process subscriptions, deliver AI-generated outputs, and communicate important account or billing updates."],
  ["Data sharing", "We share data only with service providers required to run Vozelto (e.g., Stripe for payments, AI model providers for generation). We do not sell your personal information."],
  ["Data security", "Access is protected with authenticated accounts and role-based permissions. Payments are handled by Stripe under PCI-compliant infrastructure."],
  ["Your choices", "You may access, update, or request deletion of your account data, and you can cancel your subscription at any time from the billing page."],
  ["Contact", "Questions about this policy? Email support@vozelto.com."],
];

export default function PrivacyPage() {
  useEffect(() => { document.title = "Privacy Policy — Vozelto"; }, []);
  return <LegalShell title="Privacy Policy" sections={SECTIONS} />;
}

export function LegalShell({ title, sections }) {
  return (
    <div className="min-h-screen bg-[#0D0D14] text-white grain-bg" data-testid="legal-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0D0D14]/70 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/"><Logo variant="horizontal" height={28} showTagline={false} /></Link>
          <Link to="/" data-testid="legal-back" className="text-sm text-[#9a9a9a] hover:text-white flex items-center gap-1.5">
            <ArrowLeft size={15} /> Back to home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-14">
        <h1 className="font-head font-extrabold text-3xl md:text-4xl tracking-tight">{title}</h1>
        <p className="text-sm text-[#7a7a7a] mt-2">Last updated {new Date().toLocaleDateString()}</p>
        <div className="mt-8 space-y-8">
          {sections.map(([h, body]) => (
            <section key={h}>
              <h2 className="font-head font-semibold text-xl">{h}</h2>
              {Array.isArray(body) ? (
                <ul className="mt-3 space-y-2 text-[#b5b5b5] leading-relaxed list-disc pl-5">
                  {body.map((li, i) => <li key={i}>{li}</li>)}
                </ul>
              ) : (
                <p className="mt-2 text-[#b5b5b5] leading-relaxed">{body}</p>
              )}
            </section>
          ))}
        </div>
        <p className="mt-12 text-xs text-[#5a5a5a]">Questions about this policy? Contact us at support@vozelto.com.</p>
      </main>
    </div>
  );
}
